/*eslint-disable*/

import {
  computed, onMounted, ref,
} from '@vue/composition-api'
import { userRoleToText } from '@/constants/roles'
import { download } from '@/utils/download'

export default {
  name: 'index',
  emits: ['inview'],
  props: {
    message: Object,
  },
  setup(props, { emit }) {
    const wrap = ref(null)

    // {{ message.yours ? 'Вы' : message.userRole }}
    const sender = computed(() => {
      const { message } = props
      if (message.yours) return 'Вы'
      if (message.userRole === 'dispatcher' || message.userRole === 'admin') return userRoleToText[message.userRole]
      return message.companyName
        ? message.companyName
        : userRoleToText[message.userRole]
    })
    const getSizeTitle = (size) => {
      let newSize = size
      if (newSize < 1000) return `${newSize} Б`
      newSize /= 1000
      if (newSize < 1000) return `${newSize} КБ`
      newSize /= 1000
      return `${newSize} МБ`
    }

    onMounted(() => {
      if (wrap.value) {
        const wrapper = wrap.value
        const io = new IntersectionObserver((entries, observer) => {
          if (entries) {
            const [entry] = entries
            if (entry.isIntersecting) {
              observer.unobserve(wrapper)
              emit('inview')
            }
          }
        })
        io.observe(wrapper)
      }
    })


    return {
      wrap,
      sender,
      download,
      getSizeTitle,
    }
  },
}
